module.exports = __webpack_public_path__ + "img/puptitle7.51403672.png";